export class TenantPanelController {
    static $inject = ['$stateParams', '$sce', 'LoadingService', '$translate', 'TENANTS_IFRAME_URL', 'TenantService'];
    constructor($stateParams, $sce, LoadingService, $translate, TENANTS_IFRAME_URL, TenantService) {
        'ngInject';
        this.$stateParams = $stateParams;
        this.$sce = $sce;
        this.LoadingService = LoadingService;
        this.$translate = $translate;
        this.TENANTS_IFRAME_URL = TENANTS_IFRAME_URL;
        this.TenantService = TenantService;
    }
    async $onInit() {
        const params = this.$stateParams.path;
        const tenantIframeUrl = this.TenantService.addTenantPrefixToUrl(this.TENANTS_IFRAME_URL);
        const previusFrameUrl = params
            ? `${tenantIframeUrl}${params}`
            : tenantIframeUrl;
        this.frameUrl = this.$sce.trustAsResourceUrl(previusFrameUrl);
        if (this.LoadingService?.startLoading) {
            this.LoadingService.startLoading();
        }
        // Use promise form to avoid potential race with translation loader
        this.$translate('tenantPanelView.errorMessage').then(msg => {
            this.errorMessage = msg;
        });
    }
    onFrontendLoad() {
        this.LoadingService.stopLoading();
    }
    onFrontendError() {
        this.LoadingService.stopLoading();
    }
}
// Explicit DI annotation to ensure reliable injection after build tooling upgrades
TenantPanelController.$inject = ['$stateParams', '$sce', 'LoadingService', '$translate', 'TENANTS_IFRAME_URL', 'TenantService'];
